export const config = {
  local: {
    jwtName: 'urtwm',
    noImage: '/static/img/no_image.jpg'
  },
  api: {
    url: 'https://api.urtwm.com/api/v3'
  }
}
export const routing = {
    users: "users",
    login: "login",
    recovery: "login/recovery",
    reset: "login/reset",
    roles: "roles",
    customers: "customers",
    countries: "countries",
    genders: "genders",
    states: "states",
    galleries: "galleries",
    gallery_images: "gallery-images",
    gallery_types: "gallery-types",
    media: "image-upload",
    attributes: "attributes",
    attribute_types: "attribute-types",
    suburbs: "suburbs",
    products: "products",
    product_attributes: "product-attributes",
    event_types: "event-types",
    events: "events",
    post_categories: "post-categories",
    posts: "posts",
    pages: "pages",
    portfolio: "portfolio",
    markets: "markets",
    sectors: "sectors"
};




// WEBPACK FOOTER //
// ./src/assets/js/config/base.js